import { createContext, useContext, useState } from "react";

const ApplicationServicesContext = createContext({});

export const ApplicationServicesProvider = ({ children }) => {
    const [contextData, setContextData] = useState({});

    return(
        <ApplicationServicesContext.Provider value={{ contextData, setContextData }}>
            { children }
        </ApplicationServicesContext.Provider>
    );
};

export const ApplicationServicesConsumer = () => {
    return useContext(ApplicationServicesContext);
};

export default ApplicationServicesContext;